export var IdWalkingCitizens;
(function (IdWalkingCitizens) {
    IdWalkingCitizens["Boy"] = "boy";
    IdWalkingCitizens["Girl"] = "girl";
    IdWalkingCitizens["Man"] = "man";
    IdWalkingCitizens["Woman"] = "woman";
})(IdWalkingCitizens || (IdWalkingCitizens = {}));



//////////////////
// WEBPACK FOOTER
// ./src/graphics/IdWalkingCitizens.ts
// module id = 2203
// module chunks = 3